import * as types from './types';

export const getProjectLimits = () => {
  return {
    type: types.GET_PROJECT_LIMITS,
  };
};

export const getInitialProjects = (variables) => {
  return {
    type: types.GET_INITIAL_PROJECTS,
    payload: variables,
  };
};

export const getProjects = (variables) => {
  return {
    type: types.GET_PROJECTS,
    payload: variables,
  };
};

export const archiveProject = (variables) => {
  return {
    type: types.ARCHIVE_PROJECT,
    payload: variables,
  };
};

export const deleteProject = (variables) => {
  return {
    type: types.DELETE_PROJECT,
    payload: variables,
  };
};

export const resetSearchResults = () => {
  return {
    type: types.RESET_SEARCH_RESULTS,
  };
};

export const getProjectFeatures = (variables) => {
  return {
    type: types.GET_PROJECT_FEATURES,
    payload: variables,
  };
};

export const releaseNotes = (variables) => {
  return {
    type: types.UPDATE_PROJECT_FEATURES,
    payload: { ...variables, key: 'notes_released', value: true },
  };
};

export const weddingPermissions= (variables) => {
  return {
    type: types.WEDDING_PERMISSIONS,
    payload: variables,
  };
};
